import { DefaultTheme } from 'styled-components';

import { useSelect } from '../../../modules/contexts/Select/useSelect';
import { ProaqItemInterno } from '../../../modules/types/Proaq';
import { formatDate, formataNomeMeioSiglas } from '../../../utils/functions';

export const offCanvasProaqFunction = (
  data: any | any[],
  ProaqStatus: any,
  ProaqFase: any | any[],
  componenteAf: any,
  ProaqModAquisicao: any,
  TipoCota: any,
  fluxoProaqData?: any[],
  theme?: DefaultTheme,
) => {
  const items = Array.isArray(data) ? data : [data];

  const { getSelectDominioPai } = useSelect();
  const componenteAFoptions = getSelectDominioPai(1);
  const statusProaqOptions = getSelectDominioPai(52);
  const modalidadeAquisicaoOptions = getSelectDominioPai(133);
  const submodalidadeDispensaOptions = getSelectDominioPai(137);
  const submodalidadePregaoOptions = getSelectDominioPai(139);

  return items
    .map((item, index) => {
      if (!item) return null;

      /* ===========================
         NORMALIZAÇÃO DEFENSIVA
         =========================== */
      const faseArray = Array.isArray(item.faseArray) ? item.faseArray : [];

      const itensArray = Array.isArray(item.itensArray) ? item.itensArray : [];

      /* ===========================
         FASE ATUAL
         =========================== */
      let faseAtual = 0;
      if (faseArray.length > 0) {
        faseAtual = faseArray[faseArray.length - 1].fase;
      }

      /* ===========================
         FLUXO
         =========================== */
      let fluxoProaqFaseArray: any[] = [];

      const fluxoProaq = fluxoProaqData?.find(
        (fluxo) => fluxo.id === item.__fluxoProaq__?.id,
      );

      if (fluxoProaq && Array.isArray(fluxoProaq.fluxoProaqFases)) {
        fluxoProaqFaseArray = fluxoProaq.fluxoProaqFases;
      }

      /* ===========================
         ITENS (RENDER)
         =========================== */
      const itensRender =
        itensArray.length > 0 ? (
          <ul style={{ marginBottom: '2px' }}>
            {itensArray.map((produto: any, idx: number) => (
              <li key={idx} style={{ marginBottom: '0.25rem' }}>
                <b>{produto.produto}</b>
                <span> - {TipoCota?.[produto.tipoCota]?.label ?? '-'}</span>
              </li>
            ))}
          </ul>
        ) : (
          'Nenhum item adicionado.'
        );

      /* ===========================
         VALOR TOTAL
         =========================== */
      const valorTotalEstimado =
        itensArray.length > 0
          ? `R$ ${itensArray
              .reduce(
                (somador: number, itemAtual: ProaqItemInterno) =>
                  somador + parseFloat(itemAtual.valorTotalEstimado || '0'),
                0,
              )
              .toFixed(2)}`
          : '-';

      /* ===========================
         RETURN FINAL
         =========================== */
      return {
        id: item.id ?? `Sem ID - Index ${index}`,

        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro?.nomeCompleto),

        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao?.nomeCompleto),

        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao?.nomeCompleto),

        nEdicoes: item.nEdicoes ?? 0,
        nVisualizacoes: item.nVisualizacoes ?? 0,
        nVisualizadores: item.nVisualizadores ?? 0,

        separadorLog: '',

        status:
          statusProaqOptions.find((status) => status.value == item.status)
            ?.label ?? 'Não informado',

        numeroSeiProaq: item.numeroSeiProaq ?? 'Não informado',
        numeroEtp: item.numeroEtp ?? 'Não informado',

        componenteAF:
          componenteAFoptions.find(
            (componente) => componente.value == item.componenteAF,
          )?.label ?? 'Não informado',

        modalidadeAquisicao:
          modalidadeAquisicaoOptions.find(
            (modalidade) => modalidade.value == item.modalidade,
          )?.label ?? 'Não informado',

        subtipoModalidade:
          item.modalidade === 134
            ? (submodalidadeDispensaOptions.find(
                (sub) => sub.value === item.submodalidade,
              )?.label ?? 'Não informado')
            : (submodalidadePregaoOptions.find(
                (sub) => sub.value === item.submodalidade,
              )?.label ?? 'Não informado'),

        tipoItemAquisitivo: item.denominacaoGenerica
          ? 'Denominação Genérica'
          : 'Kit de Produtos DAF',

        denominacaoOuKit: item.denominacaoGenerica ? (
          <b>{item.denominacaoGenerica.denominacaoGenerica}</b>
        ) : item.KitProdutoDAF ? (
          <b>{item.KitProdutoDAF.nomeKit}</b>
        ) : (
          'N/A'
        ),

        separador: '',

        // responsavel: item.proaqResponsavel
        //   ? formataNomeMeioSiglas(item.proaqResponsavel.responsavel)
        //   : 'Não informado',

        separadorFase: '',
        // separadorItem: '',

        // itens: itensRender,
        // valorTotalEstimado,

        observacoes: item.observacoes ?? 'Sem observações',
      };
    })
    .filter(Boolean);
};
